<!-- @format -->

<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-lg-9">
      <sis-breadcrumbs></sis-breadcrumbs>
      <sis-page-title
        [dataCy]="'course-unit-info-heading'"
        [title]="(courseUnit.name | localizedString) + ' (' + (courseUnit.credits | creditRange: 'TEXT') + ')'"
        [subTitle]="courseUnit.code"
        [showCrumbs]="true">
        <ng-container page-title="badges">
          @if (courseUnit.documentState === "DRAFT" || courseUnit.documentState === "DELETED") {
            <sis-tiny-badge [variant]="courseUnit.documentState === 'DELETED' ? 'danger' : 'accent'">
              {{ courseUnit.documentState | translate }}
            </sis-tiny-badge>
          }
        </ng-container>
      </sis-page-title>
    </div>
    <div class="col-12 col-lg-3">
      @if (isLoggedIn) {
        <div class="float-end pt-lg-5 mt-lg-5 mb-3 mb-lg-0">
          <fudis-button
            [variant]="'tertiary'"
            [label]="'SIS_COMPONENTS.STUDY.PLACE_TO_PLAN' | translate"
            [ariaLabel]="('SIS_COMPONENTS.STUDY.PLACE_TO_PLAN' | translate) + ' ' + (courseUnit.name | localizedString | plainText)"
            (handleClick)="addToPlan()">
          </fudis-button>
          @if (!inCart) {
            <fudis-button
              [variant]="'tertiary'"
              [label]="'ADD_TO_CART' | translate"
              [ariaLabel]="('ARIA_LABEL.ADD_TO_CART' | translate) + ' ' + (courseUnit.name | localizedString | plainText)"
              (handleClick)="addCourseUnitToCourseCart()"
              [icon]="'list-add'"
              data-cy="add-to-course-cart-brochure">
            </fudis-button>
          } @else {
            <fudis-button
              [variant]="'tertiary'"
              [label]="'REMOVE_FROM_CART' | translate"
              [ariaLabel]="('ARIA_LABEL.REMOVE_FROM_CART' | translate) + ' ' + (courseUnit.name | localizedString | plainText)"
              (handleClick)="removeCourseUnitFromCourseCart()"
              [icon]="'list-minus'"
              data-cy="remove-from-course-cart-brochure">
            </fudis-button>
          }
        </div>
      }
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <sis-version-selector
          [currentVersionId]="courseUnit.id"
          [options]="options"
          [popoverInfoKey]="'STUDIES.COURSE_UNIT_INFO_MODAL.VERSION_POPOVER_INFO'"
          [popoverLabelKey]="'STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_VERSION'"
          (change)="goToCourseUnitVersion($event)">
        </sis-version-selector>
      </div>
    </div>
  </div>
</div>
